// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { bulkAddProductsToBin } from "./schema/product-catalog/bulk-add-products-to-bin";
import { bulkRemoveProductsFromBin } from "./schema/product-catalog/bulk-remove-products-from-bin";
import { bulkUpdateProductFlags } from "./schema/product-catalog/bulk-update-product-flags";
import { bulkUpdateReplenishmentSettings } from "./schema/product-catalog/bulk-update-replenishment-settings";
import { createProductFamily } from "./schema/product-catalog/create-product-family";
import { createProductFamilyFromImages } from "./schema/product-catalog/create-product-family-from-images";
import { getProductDetails } from "./schema/product-catalog/get-product-details";
import { getProductFamilyDetails } from "./schema/product-catalog/get-product-family-details";
import { listProductBinsAtLocation } from "./schema/product-catalog/list-product-bins-at-location";
import { pushProductInventory } from "./schema/product-catalog/push-product-inventory";
import { searchBins } from "./schema/product-catalog/search-bins";
import { setProductBins } from "./schema/product-catalog/set-product-bins";
import { updateProduct } from "./schema/product-catalog/update-product";
import { updateProductFamily } from "./schema/product-catalog/update-product-family";
import { getImageOptimizationStatus } from "./schema/product-families/get-image-optimization-status";
import { startImageOptimization } from "./schema/product-families/start-image-optimization";
import { submitImageFeedback } from "./schema/product-families/submit-image-feedback";
import { updateImageDefaults } from "./schema/product-families/update-image-defaults";
import { uploadProductFamilyImages } from "./schema/product-families/upload-product-family-images";

export const groupC = {
  bulkAddProductsToBin,
  bulkRemoveProductsFromBin,
  bulkUpdateProductFlags,
  bulkUpdateReplenishmentSettings,
  createProductFamily,
  createProductFamilyFromImages,
  getProductDetails,
  getProductFamilyDetails,
  listProductBinsAtLocation,
  pushProductInventory,
  searchBins,
  setProductBins,
  updateProduct,
  updateProductFamily,
  getImageOptimizationStatus,
  startImageOptimization,
  submitImageFeedback,
  updateImageDefaults,
  uploadProductFamilyImages,
};
